import api from "../api/api";
import { LanguageListApiProps } from "./props";

const getLanguageListApi = async () => {
  return await api.post<LanguageListApiProps>("/api/language/list");
};

export { getLanguageListApi };
